import '../styles/score-cards.css';

import { selectIsAuthenticated } from '@/domain/auth/auth.selectors';
import { CalculateFestivalCo2 } from '@/domain/impact-calculate-festival/entities/calculate-festival-co2.entity';
import { CalculateFestivalEnv } from '@/domain/impact-calculate-festival/entities/calculate-festival-env.entity';
import { CalculateFestivalEss } from '@/domain/impact-calculate-festival/entities/calculate-festival-ess.entity';
import {
  selectImpactCalculateFestivalCo2ForProject,
  selectImpactCalculateFestivalEnvForProject,
  selectImpactCalculateFestivalEssForProject,
} from '@/domain/impact-calculate-festival/impact-calculate-festival.selectors';
import { selectCurrentProjectFestival } from '@/domain/project-festival/project-festival.selectors';
import { useAppSelector } from '@/ui/hook/store';
import { translate } from '@/ui/i18n';

import { formatProjectDatesTz } from '../../../utils/format-project-dates';
import ArrowIcon from '../assets/arrow.svg';
import FairlyScorePillLogo from '../assets/fairly-score-pill-logo.svg';
import { MainScorePill } from '../components/MainScorePill';

export function ScoreCardsFestivalC1() {
  document.documentElement.classList.add('score-card');
  document.body.classList.add('score-card');

  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const festival = useAppSelector(selectCurrentProjectFestival);
  const festivalId = festival?.id ?? 0;
  const impactCo2 = useAppSelector(
    selectImpactCalculateFestivalCo2ForProject(festivalId),
  ) satisfies CalculateFestivalCo2;

  const impactEnv = useAppSelector(
    selectImpactCalculateFestivalEnvForProject(festivalId),
  ) satisfies CalculateFestivalEnv;

  const impactEss = useAppSelector(
    selectImpactCalculateFestivalEssForProject(festivalId),
  ) satisfies CalculateFestivalEss;

  if (!isAuthenticated) {
    return <h1>{translate('PdfExports.user-not-authentified')}</h1>;
  }

  if (!festival) {
    return <h1>{translate('PdfExports.festival-not-found')}</h1>;
  }

  return (
    <div id="card1" className="score-card-summary">
      <div className="title">
        <h1>{festival.name}</h1>
        <h2>
          {formatProjectDatesTz(
            festival.startDate || '',
            festival.endDate || '',
          )}
        </h2>
      </div>
      <div className="scores">
        <div className="score-row">
          <div className="score-row-left">
            <img src={ArrowIcon} width="50" height="50" />
            {translate('Projects.co2')}
          </div>
          <MainScorePill scoreLetter={impactCo2.scoreLetter} type="co2" />
        </div>
        <div className="score-row">
          <div className="score-row-left">
            <img src={ArrowIcon} width="50" height="50" />
            {translate('Projects.env')}
          </div>
          <MainScorePill scoreLetter={impactEnv.scoreLetter} type="env" />
        </div>
        <div className="score-row">
          <div className="score-row-left">
            <img src={ArrowIcon} width="50" height="50" />
            {translate('Projects.ess')}
          </div>
          <MainScorePill scoreLetter={impactEss.scoreLetter} type="ess" />
        </div>
      </div>
      <div className="copyright">
        <img
          src={FairlyScorePillLogo}
          width="160"
          height="160"
          alt="Fairly logo"
        />
      </div>
    </div>
  );
}
